import { TFunction } from 'i18next';
import { AppState } from '../../../../redux/reducers';
import { TenantPriceList } from '../../../../models/Entities/TenantPriceLists/TenantPriceList';
import * as TenantPriceListStore from '../../../../redux/middleware/TenantPriceListsMiddleware';
import { IDropdownOption } from '@fluentui/react';
import { ErrorType } from '../../../../models/HttpError';

export interface FormValidation {
  success: boolean;
  errors: string[];
}

interface OwnProps {
  isOpen: boolean;
  openPanel: () => void;
  dismissPanel: () => void;
  TenantPriceList: TenantPriceList | undefined;
}

interface StateProps {
  isAdding?: boolean;
  addingSuccess?: boolean;
  failOnAdding?: boolean;
  isSaving?: boolean;
  savingSuccess?: boolean;
  failOnSaving?: boolean;
  error?: ErrorType;
  TenantPriceList?: TenantPriceList;
}

interface DispatchProps {
  AddTenantPriceList: typeof TenantPriceListStore.ActionCreators.AddTenantPriceList;
  UpdateTenantPriceList: typeof TenantPriceListStore.ActionCreators.UpdateTenantPriceList;
}

interface CustomEvent {
  onSavedTenantPriceList?: (tenantPriceList: TenantPriceList) => void;
}

export type Props = CustomEvent & StateProps & DispatchProps & OwnProps;

export const mapStateToProps = (state: AppState, ownProps: OwnProps) => {
  return {
    isAdding: state.TenantPriceLists?.isAddingNewOne,
    addingSuccess: state.TenantPriceLists?.successAddingNewOne,
    failOnAdding: state.TenantPriceLists?.failOnAddingNewOne,
    isSaving: state.TenantPriceLists?.isUpdatingOne,
    savingSuccess: state.TenantPriceLists?.successUpdatingOne,
    failOnSaving: state.TenantPriceLists?.failOnUpdatingOne,
    error: state.TenantPriceLists?.error,
    TenantPriceList: ownProps.TenantPriceList
  };
};

export const mapDispatchToProps = {
  ...TenantPriceListStore.ActionCreators
};

// Price list type options
export const PriceListTypeOptions: IDropdownOption[] = [
  { key: 'P', text: 'Pagador' },
  { key: 'C', text: 'Cobrador' }
];

// Form state
export interface TenantPriceListFormState {
  listName: string | undefined;
  comments: string | undefined;
  priceListType: string | undefined;
}

export const initialFormState: TenantPriceListFormState = {
  listName: undefined,
  comments: undefined,
  priceListType: undefined
};

export const formStateFromTenantPriceList = (tpl: TenantPriceList): TenantPriceListFormState => ({
  listName: tpl.priceList.listName,
  comments: tpl.priceList.comments,
  priceListType: tpl.priceListType
});

export const validateForm = (state: TenantPriceListFormState, t: TFunction): FormValidation => {
  const errors: string[] = [];

  if (!state.listName?.trim()) {
    errors.push(t('tenantPriceListForm.formValidation.requiredPriceListName'));
  }

  if (!state.priceListType) {
    errors.push(t('tenantPriceListForm.formValidation.requiredPriceListType'));
  }

  return { success: errors.length === 0, errors };
};
